module.exports = __webpack_public_path__ + "img/client-6.9358fbcc.png";